<template>
  <div class="grid gap-6">
    <slot></slot>
  </div>
</template>
